import React, { useEffect } from 'react';
import styled from 'styled-components';
import useStore from '../../Store';

// Component to display the 3D viewer in AI Product Staging dialog
// Uses a portal to move the main ZakekeViewer instance into this container
// when the AI Studio is open

interface Preview3DViewProps {
	className?: string;
}

const VIEWER_CONTAINER_ID = 'ai-studio-viewer-container';

export const Preview3DView: React.FC<Preview3DViewProps> = ({ className }) => {
	const { setAIStudioViewerContainerId } = useStore();

	useEffect(() => {
		console.log('[Preview3DView] Component mounted, setting container ID:', VIEWER_CONTAINER_ID);

		// Verify container exists in DOM
		const container = document.getElementById(VIEWER_CONTAINER_ID);
		console.log('[Preview3DView] Container exists in DOM:', !!container);

		// Set the container ID when component mounts
		setAIStudioViewerContainerId(VIEWER_CONTAINER_ID);

		// Trigger a window resize event to ensure the 3D viewer resizes properly
		// This is needed because the viewer was initialized in a different container
		// and needs to recalculate its dimensions after being portaled
		const triggerResize = () => {
			console.log('[Preview3DView] Triggering window resize event');
			window.dispatchEvent(new Event('resize'));
		};

		// Trigger resize after a short delay to ensure the portal is complete
		const timer1 = setTimeout(triggerResize, 100);
		const timer2 = setTimeout(triggerResize, 300);
		const timer3 = setTimeout(triggerResize, 500);

		// Clean up when component unmounts
		return () => {
			console.log('[Preview3DView] Component unmounting, clearing container ID');
			clearTimeout(timer1);
			clearTimeout(timer2);
			clearTimeout(timer3);
			setAIStudioViewerContainerId(null);
		};
	}, [setAIStudioViewerContainerId]);

	return (
		<Preview3DViewContainer id={VIEWER_CONTAINER_ID} className={className}>
			{/* The ZakekeViewer will be portaled here from Viewer3D.tsx */}
		</Preview3DViewContainer>
	);
};

// Styled Components

const Preview3DViewContainer = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
	display: block;
	background: #f2f2f2;
	border-radius: 1rem;
	overflow: hidden;
	z-index: 1;

	/* Ensure the portaled viewer takes full space */
	> div {
		width: 100% !important;
		height: 100% !important;
		position: absolute !important;
		top: 0 !important;
		left: 0 !important;
	}

	/* Make sure canvas is visible and properly sized */
	canvas {
		width: 100% !important;
		height: 100% !important;
		display: block !important;
		visibility: visible !important;
		opacity: 1 !important;
		transform: none !important;
		position: absolute !important;
		top: 0 !important;
		left: 0 !important;
		background: #f2f2f2 !important;
	}
`;
